import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Quarto } from 'src/app/model';

@Component({
  selector: 'app-quartos',
  standalone: false,
  templateUrl: './quartos.component.html',
  styleUrl: './quartos.component.scss'
})
export class QuartosComponent implements OnInit {
  constructor(private modalService: NgbModal){}

  ngOnInit(): void {}

  @Input() quartos: Quarto[] = [];
  @Input() modal: boolean = true;

  incrementaQuartos() {
    this.quartos.push(new Quarto());
  }

  decrementaQuartos() {
    this.quartos.pop();
  }

  fecharModal()  {
    this.modalService.dismissAll();
  }
}
